import classNames from 'classnames';
import debounce from 'lodash/debounce';
import React, { useCallback, useEffect, useState } from 'react';

import updateConditionDescriptionOperation from 'editor/src/store/design/operation/updateConditionDescriptionOperation';
import { ConditionAddress } from 'editor/src/store/design/types';
import { useDispatch } from 'editor/src/store/hooks';

import useTr from 'editor/src/util/useTr';

import styles from './index.module.scss';

interface Props {
  spreadIndex: number;
  conditionId: string;
  conditionDescription: string | undefined;
}

function ConditionDescriptionInput({ spreadIndex, conditionId, conditionDescription }: Props) {
  const tr = useTr();
  const [description, setDescription] = useState(conditionDescription ?? '');
  const dispatch = useDispatch();

  useEffect(() => {
    setDescription(conditionDescription ?? '');
  }, [conditionDescription]);

  const onUpdateDispatch = useCallback(
    debounce((address: ConditionAddress, value: string) => {
      dispatch(updateConditionDescriptionOperation(address, value));
    }, 300),
    [],
  );

  function onUpdate(event: React.ChangeEvent) {
    const { value } = event.target as HTMLTextAreaElement;
    setDescription(value);
    onUpdateDispatch({ spreadIndex, conditionId }, value);
  }

  function onBlur(event: React.FocusEvent) {
    const { value } = event.target as HTMLTextAreaElement;
    setDescription(value);
    dispatch(updateConditionDescriptionOperation({ spreadIndex, conditionId }, value));
  }

  return (
    <textarea
      className={classNames(styles.ConditionDescriptionInput, 'cy-condition-description-input')}
      value={description}
      rows={2}
      placeholder={tr(
        'editor-condition-description-placeholder',
        'e.g. Choose the language for the greeting and labels',
      )}
      onChange={onUpdate}
      onBlur={onBlur}
    />
  );
}

export default React.memo(ConditionDescriptionInput);
